import { useCallback, useContext, useMemo } from 'react';
import { authService } from '../../services';
import { BridgeContext } from '@nackle/bridge';

export const useAuthState = () => {
    /**
     * Any stored data relevant to the user's auth state.
     */
    const contextData = useContext( BridgeContext );

    /**
     * The permissions the user has.
     * @type { string[] }
     */
    const permissions = useMemo( () => authService.getPermissions(), [] );

    /**
     * Checks to see if the user has the provided permission.
     * 
     * @param { string } permissionKey - The key of the permission to check for.
     * @returns { boolean }
     */
    const hasPermission = useCallback( ( permissionKey ) => {
        if ( permissionKey ) {
            return permissions.includes( permissionKey );
        }
        return false;
    }, [ permissions ] );

    return useMemo( () => {
        return {
            ...( contextData?.auth?.state || {} ),
            permissions,
            hasPermission,
        };
    }, [ contextData, permissions, hasPermission ] );
};
